<template>
	<div class="cc-control">
		<div v-if="$cc_on.value" @click="turn_off" class="on-button cc-button"></div>
		<div v-if="!$cc_on.value" @click="turn_on" class="off-button cc-button"></div>
	</div>
</template>

<script>
const component = {
	name: 'CC',
	data() {
		return {
			is_on: false
		};
	},
	mounted() {
		const cc_on = localStorage.getItem('cc_on');
		if (cc_on !== undefined) {
			this.$cc_on.value = JSON.parse(cc_on);
		}
	},
	methods: {
		turn_on() {
			this.$cc_on.value = true;
			localStorage.setItem('cc_on', JSON.stringify(true));
		},
		turn_off() {
			this.$cc_on.value = false;
			localStorage.setItem('cc_on', JSON.stringify(false));
		},
	},
};
export default component;
</script>

<style lang="scss">
.cc-control {
	position: fixed;
	bottom: 64px;
	right: 100px;
	z-index: 6;

	@media(max-width: 1600px) {
		right: 40px;
	}

	@media(max-width: 1280px) {
		right: 22px;
	}

	@media(max-width: 600px) {
		bottom: 115px;
		right: 4%;
	}

	.cc-button {
		width: 64px;
		height: 64px;
		background-size: cover;
		cursor: pointer;

		@media(min-width: 1600px) {
			width: 70px;
			height: 70px;
		}

		@media(max-width:1600px) {
			width: 58px;
			height: 58px;
		}

		@media(max-width: 1280px) {
			width: 50px;
			height: 50px;
		}

		@media(max-width: 600px) {
			width: 50px;
			height: 50px;
		}
	}

	.on-button {
		background-image: url(/themes/rise-theme/dist/images/estate/CC_active.png);
	}

	.off-button {
		background-image: url(/themes/rise-theme/dist/images/estate/CC_inactive.png);
	}
}
</style>
